<template>
  <div
    class="ct-tooltip"
    :class="[{ 'ct-tooltip--active': isActive }]"
  >
    <button
      class="ct-tooltip__button"
      @mouseenter="toggleTooltip(true)"
      @mouseleave="toggleTooltip(false)"
    >
      <IconExclamationCircle class="ct-tooltip__trigger" />
    </button>
    <div
      v-show="isActive"
      role="tooltip"
      class="ct-tooltip__container"
    >
      <span class="ct-tooltip__container--arrow">
        <span
          class="ct-tooltip__arrow-icon"
        />
      </span>
      <div class="ct-tooltip__text">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import IconExclamationCircle from "@/components/Icon/ExclamationCircle.vue"
import { ref } from "vue"

const isActive = ref(false)
function toggleTooltip(boolean: boolean) {
	isActive.value = typeof boolean === "boolean" ? boolean : !boolean
}
</script>
  <style lang="postcss" scoped>
@reference '#importtailwindcss';

  .ct-tooltip {
    @apply relative flex items-center;

    &__trigger {
      @apply w-6 h-6 text-white cursor-pointer;
    }

    &__container {
      @apply absolute top-full z-10 min-w-40 -right-1/2 mt-4 lg:-right-3/4;

      &--arrow {
        @apply relative block;
      }
    }

    &__arrow-icon {
      @apply absolute -z-10 top-0 -translate-x-1/2 -translate-y-1/2 right-[3.5%]
      lg:right-[5.5%] transform rotate-45 w-4 h-4 bg-theme-primary border-l border-t border-theme-primary;

    }

    &__text {
      @apply p-2.5 bg-theme-primary text-white custom-font__small-text-2 text-nowrap;
    }
  }
  </style>
